import styled from "styled-components";
import IPanel from "./interface";

const Container = styled.div<IPanel>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 3px;
  background-color: var(--panel-body);
  color: var(--default-color-font);
  border: 1px solid var(--border-color);
  padding: 0.5rem 1rem;
  border-radius: 3px;
  box-shadow: rgb(60 64 67 / 30%) 0px 1px 2px 0px, rgb(60 64 67 / 15%) 0px 1px 3px 1px;

  ${(props) => props.styleInline}
`;

export default Container;
